import { render, staticRenderFns } from "./InspectorMain.vue?vue&type=template&id=39aff340&scoped=true&"
import script from "./InspectorMain.vue?vue&type=script&setup=true&lang=js&"
export * from "./InspectorMain.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./InspectorMain.vue?vue&type=style&index=0&id=39aff340&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aff340",
  null
  
)

export default component.exports